import React, { useEffect, useState } from 'react';
import RotateArrow from '../../../../icons/rotate-arrow';
import IconDownload from '../../../../icons/download';
import { downloadVendorDriverReport } from '../utils/vendorReport';

function VendorToolbar(props) {
   const { vendorFilters, setVendorFilters, openAddVendor, refetchData, isRefetching } = props;
   const [downloadingReport, setDownloadingReport] = useState(false);

   const handleDownloadReport = async () => {
      if (downloadingReport) return;
      setDownloadingReport(true);
      try {
         await downloadVendorDriverReport();
      } finally {
         setDownloadingReport(false);
      }
   };

   const [searchInput, setSearchInput] = useState(vendorFilters.vendorSearch); // auxiliary state for input

   // Debounce to update search filter
   useEffect(() => {
      if (searchInput === vendorFilters.vendorSearch) return;

      const handler = setTimeout(() => {
         setVendorFilters((prev) => ({
            ...prev,
            vendorSearch: (searchInput && searchInput.trim()) || '',
         }));
      }, 500); // debounce 500ms

      return () => clearTimeout(handler);
   }, [searchInput]);

   return (
      <div>
         <div className="vendors__button-bar">
            <h2>Vendors</h2>
            <div className="vendors__download-upload-buttons">
               <button
                  className="vendors__btn-hover"
                  onClick={handleDownloadReport}
                  disabled={downloadingReport}
               >
                  <div style={{ height: '0.8rem' }}>
                     <IconDownload className="h-100" />
                  </div>
                  <div>{downloadingReport ? 'Downloading...' : 'Download Driver Report'}</div>
               </button>
               <button className="btn btn-primary" onClick={openAddVendor}>
                  <i className="fa fa-plus mr-1"></i> Add Vendor
               </button>
            </div>
         </div>

         <div className="vendors__toolbar">
            <div className="vendors__toolbar-left">
               <div className="vendors__search-input">
                  <i className="fa fa-search search-icon"></i>
                  <input
                     type="text"
                     className="form-control"
                     placeholder="Search vendors..."
                     value={searchInput}
                     onChange={(e) => !isRefetching && setSearchInput(e.target.value)}
                  />
               </div>

               <select
                  className="vendors__filter-select"
                  value={vendorFilters.vendorStatus}
                  onChange={function (e) {
                     setVendorFilters((prev) => ({ ...prev, vendorStatus: e.target.value }));
                  }}
               >
                  <option value="all">All Status</option>
                  <option value="true">Active</option>
                  <option value="false">Inactive</option>
               </select>

               <button className="btn-filter" onClick={refetchData}>
                  <div className="vendor__btn-refresh">
                     <RotateArrow className="h-100" />
                  </div>
               </button>
            </div>
         </div>
      </div>
   );
}

export default VendorToolbar;
